const en = {
  firstButtonLabel: 'first',
  lastButtonLabel: 'last',
  nextButtonLabel: 'next',
  page: 'page',
  pagination: 'pagination',
  previousButtonLabel: 'previous',
  slash: 'of'
};
const fi = {
  firstButtonLabel: 'ensimmäinen',
  lastButtonLabel: 'viimeinen',
  nextButtonLabel: 'seuraava',
  page: 'sivu',
  pagination: 'sivutus',
  previousButtonLabel: 'edellinen',
  slash: '/'
};
const sv = {
  firstButtonLabel: 'främst',
  lastButtonLabel: 'sist',
  nextButtonLabel: 'följande',
  page: 'sida',
  pagination: 'paginering',
  previousButtonLabel: 'föregående',
  slash: 'av'
};

/**
 * Used in pagination.tsx.
 * Pagination uses these objects to create correct aria-labels that match locale.
 * @param key string ['en', 'fi', 'sv']
 * @returns Object containing labels that match given language key. By default returns English one.
 */
export const getMessages = key => {
  if (key === 'fi') {
    return fi;
  }
  if (key === 'sv') {
    return sv;
  }
  return en;
};